<template>
  <div v-if="products.length" class="combo-item-products">
    <div class="combo-item-products-body scroll-black">
      <div class="combo-item-product" v-for="product in products" :key="product.id" :class="{'active': filterActiveProduct(product)}"
           @click="selectComboItem(product, groupId, false)"
      >
        <div class="combo-item-product-picture">
          <img :src="product.PICTURE">
        </div>
        <div>
          {{ product.NAME }}
        </div>
      </div>
    </div>
    <div>
      <div v-if="comboItemProductOffers.length" class="combo-item-product-offers">
        <div class="combo-item-product-offer" v-for="offer in comboItemProductOffers" :key="offer.ID"
             @click="selectComboItem(offer, groupId, true)" :class="{'active': isActiveCombo(comboItems, groupId, offer.code)}">
          {{ offer.OFFER_NAME }}
        </div>
      </div>
      <div class="combo-item-products-footer">
        <div class="button-combo-cancel" @click="cancelChangeCombo()">{{ phrases.COMBO_ITEM_BACK }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ComboUtils from "@/components/combos/ComboUtils.vue";

export default {
  name: "ComboItemProducts",
  components: {},
  props: ["products"],
  computed: {
    ...mapGetters('combo', {
      combo: 'getCombo',
      comboItems: 'getComboItems',
      comboItemProducts: 'getComboItemProducts',
      comboItemProductOffers: 'getComboItemProductOffers',
      groupId: 'getComboItemGroupId',
    }),
    ...mapGetters('order', {
      orderCombos: 'getOrderCombos'
    })
  },
  methods:{
    selectComboItem: function (product, groupId, isOffer){
      const component = this;
      const comboItems = component.comboItems.filter( i => { return i.groupId !==  groupId});
      const productTitle = component.comboItemProductTitle(isOffer, product);
      if(product.offers !== undefined && product.offers !== null && product.offers.length){
        component.$store.commit('combo/setComboItemProductOffers', product.offers);
        return;
      }
      comboItems.push({'groupId': groupId, 'productId': product.code, 'productTitle': productTitle});
      component.$store.commit('combo/setComboItems', comboItems);
      component.$store.commit('combo/setComboItemProducts', []);
    }
  },
  mixins: [ComboUtils]
}
</script>

<style scoped lang="scss">

.combo-item-products{
  padding: 1rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;
  overflow-y: scroll;
}

.combo-item-product-picture{
  img{
    width: 100%;
  }
}

.combo-item-products-footer{
  margin: 0.5rem 0 0 0;
}

.button-combo-cancel{
  background-color: #e0e0e0;
  font-family: "Panton SemiBold", sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #595959;
  text-transform: uppercase;
  cursor: pointer;
  position: relative;
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.25rem;
}

.combo-item-products-body{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  overflow-y: auto;
  padding: 0.15rem;

  &.scroll-black::-webkit-scrollbar-track{
    background-color: #fff;
  }

  .combo-item-product{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
    margin-right: 0.5rem;
    font-size: 0.875rem;
    line-height: 1rem;
    text-align: center;
    cursor: pointer;
    box-shadow: #ddd9d9 0px 0px 3px 1px;
    flex-direction: column;

    &.active{
      box-shadow: #e56621 0px 0px 3px 1px;
    }
  }
}

.combo-item-product-offers{
  padding: 0.5rem;

  .combo-item-product-offer{
    cursor: pointer;
    border: 1px solid #f0f1f2;
    border-radius: 0.25rem;
    padding: 0.5rem 0;
    text-align: center;
    margin: 0 0 0.25rem 0;

    &.active{
      box-shadow: #e56621 0px 0px 3px 1px;
    }
  }
}
</style>